export default __webpack_public_path__ + "static/proxima-nova-900-i-d53f56dba7b1c615461797138d62e61c.woff2";